import React, { FC, useMemo } from 'react';
import { QRCodeSVG } from 'qrcode.react';

import { getUniversalUrl } from 'app/lib/get-universal-url';

type QRCodeProps = {
  searchParams?: Record<string, string | null>;
  value: string;
  className?: string;
  size?: number;
};

const LOGO_URL = '/images/background-logo.svg';

export const QRCode: FC<QRCodeProps> = ({
  className,
  value: baseValue,
  searchParams,
  size = 100,
}) => {
  const value = useMemo(() => {
    if (searchParams) {
      const url = new URL(baseValue);

      for (const key in searchParams) {
        url.searchParams.append(key, searchParams[key] || '');
      }

      return url.href;
    }

    return baseValue;
  }, [baseValue, searchParams]);

  const imageSettings = useMemo(() => {
    const imageSizePercent = 30;
    const imageSize = (size / 100) * imageSizePercent;

    return {
      src: getUniversalUrl(LOGO_URL),
      height: imageSize,
      width: imageSize,
      excavate: true,
    };
  }, []);

  return (
    <QRCodeSVG className={className}
               value={value}
               size={size}
               level="H"
               imageSettings={imageSettings} />
  );
};
